import React from 'react';
import { Link } from 'react-router';
import { Col, Row } from 'react-bootstrap';
import { InfoLabel } from '../../../../../../common/components';
import displayName from '../../../../../../helpers/displayName';
import DeclarationQuestions from '../../../DeclarationQuestions/DeclarationQuestions';
import capitalise from '../../../../../../helpers/capitialise';
import { isOwner } from '../../../../../auth/redux/authActions';
import { AgreedDeclaration } from '../../../AgreedDeclaration/AgreedDeclaration';

const getEndDate = (quoteSchemeType, resource) => {
  if (quoteSchemeType !== 'annual') {
    return  resource.expires_at ?? resource?.ends_at ?? resource?.metadata?.end_date?.slice(0,10);
  }
  return  resource.expires_at;
};

const getRenewalStatus = (isIssued, isRenewal, renewalStatus, policyRenewalStatus) => {
  if (isIssued) {
    return renewalStatus;
  }
  if (isRenewal) {
    return policyRenewalStatus;
  }
  return '';

};
const LeisureTravelSummary = ({
  resource,
  policy,
  premiums,
  status,
  quoteDate
}) => {
  const options = resource?.metadata?.options;
  const policyOptions = Object.keys(options).reduce((carry, optionKey) => {
    const option = options[optionKey];
    if (!option) {
      return carry;
    }
    if (optionKey === 'advisory_message') {
      return carry;
    }
    if (optionKey === 'hazardous_activities') {
      carry.push(`Hazardous Activities ${option}`);
      return carry;
    }
    carry.push(capitalise(optionKey.replace(/_/g, ' ')));
    return carry;
  }, []);

  const { region, destinations, scheme_type: quoteSchemeType, traveller_group: travellerGroup, medical_declaration: medicalDeclaration, medical_declaration_questions: medicalDeclarationQuestions, renewal_declaration: renewalDeclaration, mta_declaration: mtaDeclaration  } =  resource?.metadata ?? {};
  const destination = region ? displayName(region, true) : destinations?.join(', ');
  const relevantPremiums = premiums
    ? premiums.filter((premium) => {
        const premiumSchemeType = premium?.attributes?.scheme?.scheme_type;
        return premiumSchemeType
          ? premiumSchemeType.toLowerCase().includes(quoteSchemeType)
          : '';
      })
    : [];

  const isAnnual = quoteSchemeType === 'annual';

  const renewalStatus = isAnnual ? getRenewalStatus(!!resource.policy_number, resource.quote_type === 'renewal', resource.renewal_status,  policy?.data?.attributes?.renewal_status): '';

  const firstPremium  = relevantPremiums.slice(-1)[0];

  return (
    <>
      <div className="summary-section">
        <Row>
          <Col sm={12} className="section-title">
            <h4>Summary</h4>
          </Col>
          <Col sm={6}>
            <InfoLabel
              label="Product"
              value={resource.product_name}
              labelSize={4}
              wrapperClass={'clear-margin'}
            />
            {!!policy?.data?.attributes && (
              <InfoLabel
                labelSize={4}
                label="Policy"
                value={
                  <Link to={'/policies/issued/' + policy.data.id} onlyActiveOnIndex>
                    {policy.data.attributes.policy_number + ' (' + status + ')'}
                  </Link>
                }
              />
            )}
            <InfoLabel
              label="Start Date"
              date
              value={resource.starts_at ?? resource.commences_at}
              labelSize={4}
              wrapperClass={'clear-margin'}
            />
            <InfoLabel
              label="End Date"
              date
              value={getEndDate(quoteSchemeType, resource)}

              labelSize={4}
              wrapperClass={'clear-margin'}
            />
            <InfoLabel
              label="Destination"
              labelSize={4}
              value={destination}
              wrapperClass={'clear-margin'}
            />
            <InfoLabel
              label="Traveller Group"
              value={displayName(travellerGroup, true)}
              labelSize={4}
              wrapperClass={'clear-margin'}
            />
          </Col>
          <Col sm={6}>
            <InfoLabel
              label="Scheme"
              value={firstPremium?.attributes?.scheme.name ?? '-'}
              labelSize={4}
              wrapperClass={'clear-margin'}
            />
            <InfoLabel
              label="Channel"
              value={resource.channel_name}
              labelSize={4}
              wrapperClass={'clear-margin'}
            />
            <InfoLabel
              label="Quote Date"
              date
              value={quoteDate}
              labelSize={4}
              wrapperClass={'clear-margin'}
            />
            <InfoLabel
              label="Issue Date"
              date
              value={resource.issued_at}
              labelSize={4}
              wrapperClass={'clear-margin'}
            />

            {isOwner() && (
              <InfoLabel
                label="Last Updated Date"
                dateTime
                value={resource.updated_at}
                labelSize={4}
                wrapperClass={'clear-margin'}
              />
            )}
            <InfoLabel
              label="Policy options"
              value={policyOptions.join(', ')}
              labelSize={4}
              wrapperClass={'clear-margin'}
            />

            {renewalStatus && (
              <div>
                <InfoLabel label="Renewal Status" value={renewalStatus} labelSize={4} />
              </div>
            )}
            {isAnnual && resource.policy_number && (
              <div>
                <InfoLabel
                  label="Term Number"
                  value={resource.term_number}
                  labelSize={4}
                />
              </div>
            )}
          </Col>
          <Col sm={12}>
            <DeclarationQuestions
              wrapperClass={'clear-margin declaration-display'}
              declaration={medicalDeclaration}
              questions={medicalDeclarationQuestions?? []}
            />
          </Col>
          <Col sm={12}>
            <AgreedDeclaration
              declaration={renewalDeclaration}
              label={'Renewal Declaration'}
            />
          </Col>
          <Col sm={12}>
            <AgreedDeclaration
              declaration={mtaDeclaration}
              label={'Mta Declaration'}
            />
          </Col>
        </Row>
        <div className="hr" />
      </div>
    </>
  );
};

export default LeisureTravelSummary;
